export default __webpack_public_path__ + "static/media/the_malibu.27de5453.jpg";